export const PreviewLink = ({
  text,
  onClick,
  ...props
}: {
  text: string;
  onClick: () => void;
}) => (
  <div {...props} onClick={onClick}>
    {text}
  </div>
);
